import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../../../../service/api.service';
import { CoreService } from '../../../../../service/core.service';

import * as XLSX from 'xlsx';

@Component({
  selector: 'app-reconciliation',
  templateUrl: './reconciliation.component.html',
  styleUrls: ['./reconciliation.component.css']
})
export class ReconciliationComponent implements OnInit {
  @ViewChild('closeModal', { static: false }) closeModal: ElementRef;
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  impRes: any;
  excelErr = '';
  excelfileList: FileList;
  isSubmitInProg = false;
  inProgressMg = '';
  added_rows_count = 0;
  existing_rows_count = 0;
  existing_rows = [];
  reconciliationimportLimit = 2000;
  genSysUnit = false;
  fileName = 'reconciliation_import_sample_document.xlsx';
  headers: any;
  selectedHeaders: any = {};
  excelData: any[] = [];
  mappedData: any[] = [];
  bank_accounts: any;
  from_date: string | Blob;
  to_date: string | Blob;
  account: string | Blob;
  transactions: any;
  reconciliation: any;
  showMappingCard: boolean = false;
  printError = [];
  errObjArr = {
    accntErr: null, fromDateErr: null, toDateErr: null

  };

  constructor(private apiService: ApiService, private coreService: CoreService) { }

  ngOnInit() {

    this.selectedHeaders = {
      date: '',
      description: '',
      payee: '',
      reference: '',
      withdrawals: '',
      deposits: ''
    };
    this.getAllBankAccount();
    this.getBankTransactions();
  }

  import() {
    this.excelErr = "";
    if (this.excelfileList && this.excelfileList.length > 0) {
      this.impRes = null;
      let file: File = this.excelfileList[0];
      let formData: FormData = new FormData();
      formData.append('file', file, file.name);
      formData.append('show_reason', '1');
      this.isSubmitInProg = true;
      this.apiService.importReconciliationExcel(formData).subscribe((res) => {
      
      });
    } else {
      this.excelErr = "Please Choose An Excel File";
    }
  }


  clearForm() {
    this.from_date = null;
    this.to_date = null;
    this.account = null;
    this.excelfileList = null;
    this.excelErr = '';
    this.isSubmitInProg = false;
    this.inProgressMg = '';
    this.added_rows_count = 0;
    this.existing_rows_count = 0;
    this.existing_rows = [];
    this.headers = null;
    this.selectedHeaders = {
      date: '',
      description: '',
      payee: '',
      reference: '',
      withdrawals: '',
      deposit: ''
    };
    this.excelData = [];
    this.mappedData = [];
    this.impRes = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }


  downloadSheet() {
    /* table id is passed over here */
    let element = document.getElementById('export-group');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { raw: true });

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  fileChange(event) {
    this.excelfileList = event.target.files;
    if (this.excelfileList.length > 0) {
      const file: File = this.excelfileList[0];
      const reader: FileReader = new FileReader();

      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // Extract headers from the first row
        this.headers = jsonData[0];

        // Extract data starting from second row
        this.excelData = jsonData.slice(1);
      };

      reader.readAsArrayBuffer(file);
    }

  }

  getAllBankAccount() {
    this.apiService.getAllBankAccount().subscribe((res) => {
      this.bank_accounts = res.data;
    });
  }

  getBankTransactions() {
    this.apiService.getBankTransactions().subscribe((res) => {
      this.transactions = res;
    });
  }

  importNew() {
    this.showMappingCard = true;
    this.inProgressMg = "";
    this.excelErr = "";
  
    this.printError = [];
    let hasError = false;
  
    if (!this.account) {
      this.errObjArr.accntErr = "t";
      this.printError.push({ fieldErr: 'Account Required' });
      hasError = true;
    } else {
      this.errObjArr.accntErr = "f";
    }
  
    if (!this.from_date) {
      this.errObjArr.fromDateErr = "t";
      this.printError.push({ fieldErr: 'From Date Required' });
      hasError = true;
    } else {
      this.errObjArr.fromDateErr = "f";
    }
  
    if (!this.to_date) {
      this.errObjArr.toDateErr = "t";
      this.printError.push({ fieldErr: 'To Date Required' });
      hasError = true;
    } else {
      this.errObjArr.toDateErr = "f";
    }
  
    if (!this.excelfileList || this.excelfileList.length === 0) {
      this.excelErr = "Please Choose An Excel File";
      hasError = true;
    } else {
      this.excelErr = "";
    }
  
    if (hasError) {
     return;
    }
  
   
    this.impRes = null;
    let file: File = this.excelfileList[0];
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('show_reason', '1');
    formData.append('start', '');
    formData.append('limit', '');
    formData.append('genSysUnit', '');
  
    this.isSubmitInProg = true;
    this.inProgressMg = "Don't close this window, wait till complete, Processing.....";
    this.added_rows_count = 0;
    this.existing_rows_count = 0;
    this.existing_rows = [];
  
    this.apiService.getExcelRowCount(formData).subscribe((res) => {
      if (res.error) {
        this.isSubmitInProg = false;
        this.inProgressMg = "";
        if (res.errmsg && res.errmsg.length > 0) {
          this.excelErr = res.errmsg[0];
        } else {
          this.excelErr = 'Something Went Wrong..!!!';
        }
      } else {
        if (res.data.count > 0) {
          this.headers = this.headers; 
          this.inProgressMg += "<br>Total Row : " + res.data.count + "<br>Importing Started from Row 1 .......";
          var parts = Math.ceil(res.data.count / this.reconciliationimportLimit);
          this.importExcel(formData, 0, parts);
        } else {
          this.isSubmitInProg = false;
          this.inProgressMg = "No Data Found";
        }
      }
    });
  }
  
  // importNew() {
  //   this.showMappingCard = true;
  //   this.inProgressMg = "";
  //   this.excelErr = "";
  //   if (this.excelfileList && this.excelfileList.length > 0) {
  //     this.impRes = null;
  //     let file: File = this.excelfileList[0];
  //     let formData: FormData = new FormData();
  //     formData.append('file', file, file.name);
  //     formData.append('show_reason', '1');
  //     formData.append('start', '');
  //     formData.append('limit', '');
  //     formData.append('genSysUnit', '');
  //     this.isSubmitInProg = true;
  //     this.inProgressMg = "Don't close this window wait till complete,Processing.....";
  //     this.added_rows_count = 0;
  //     this.existing_rows_count = 0;
  //     this.existing_rows = [];
  //     this.apiService.getExcelRowCount(formData).subscribe((res) => {

  //       if (this.account == '' || this.account == undefined) {
  //         console.log('aaa')
  //         this.errObjArr.accntErr = "t";
  //         this.printError.push({ 'fieldErr': 'Required' });
  
  //       } else {
  //         this.errObjArr.accntErr = "f";
  //       }
  //       if (this.from_date == '' || this.from_date == undefined) {
  //         this.errObjArr.fromDateErr = "t";
  //         this.printError.push({ 'fieldErr': 'Required' });
  
  //       } else {
  //         this.errObjArr.fromDateErr = "f";
  //       }
  
  //       if (this.to_date == '' || this.to_date == undefined) {
  //         this.errObjArr.toDateErr = "t";
  //         this.printError.push({ 'fieldErr': 'Required' });
  
  //       } else {
  //         this.errObjArr.toDateErr = "f";
  //       }

  //       if (res.error) {
  //         this.isSubmitInProg = false;
  //         this.inProgressMg = "";
  //         if (res.errmsg && res.errmsg.length > 0) {
  //           this.excelErr = res.errmsg[0];
  //         } else {
  //           this.excelErr = 'Somthing Went Wrong..!!!';
  //         }
  //       } else {
  //         if (res.data.count > 0) {
  //            this.headers = this.headers;
  //           this.inProgressMg += "<br>Total Row : " + res.data.count + "<br>Importing Started from Row 1 .......";
  //           var parts = Math.ceil(res.data.count / this.reconciliationimportLimit);
  //           this.importExcel(formData, 0, parts);

  //         } else {
  //           this.isSubmitInProg = false;
  //           this.inProgressMg = "No Data Found";
  //         }
  //       }
  //     });
    
  //   } else {
  //      this.excelErr = "Please Choose An Excel File";
  //   }
  // }

  importExcel(formData, i, parts) {
    formData.set('start', (i * this.reconciliationimportLimit));
    formData.set('limit', this.reconciliationimportLimit);
    formData.set('genSysUnit', this.genSysUnit);

    if ((i + 1) < parts) {
      this.importExcel(formData, i + 1, parts);
      this.inProgressMg += "<br>Importing " + ((i * this.reconciliationimportLimit) + 1) + ' To ' + ((i * this.reconciliationimportLimit) + this.reconciliationimportLimit) + " Completed, Importing Started from " + (((i + 1) * this.reconciliationimportLimit) + 1) + " .......";
    } else {
      this.isSubmitInProg = false;
      this.inProgressMg += "<br>Importing Completed";
      this.impRes = {
        added_rows_count: this.added_rows_count,
        existing_rows_count: this.existing_rows_count,
        existing_rows: this.existing_rows
      };
    }

  }

  mapData() {
    this.mappedData = this.excelData.map(row => {
      return {
        date: row[this.headers.indexOf(this.selectedHeaders.date)] || '',
        description: row[this.headers.indexOf(this.selectedHeaders.description)] || '',
        payee: row[this.headers.indexOf(this.selectedHeaders.payee)] || '',
        reference: row[this.headers.indexOf(this.selectedHeaders.reference)] || '',
        withdrawals: row[this.headers.indexOf(this.selectedHeaders.withdrawals)] || '',
        deposit: row[this.headers.indexOf(this.selectedHeaders.deposit)] || '',
      };
    });
  }

 
  validate() {
    this.inProgressMg = "";
    this.excelErr = "";
    if (!this.selectedHeaders.date || this.selectedHeaders.date.trim() === '') {
      this.coreService.showMessage("Please select a Date field from the dropdown.");
      return;
    }
    if (!this.selectedHeaders.withdrawals || this.selectedHeaders.withdrawals.trim() === '') {
      this.coreService.showMessage("Please select a Withdrawals field from the dropdown.");
      return;
    }
    if (!this.selectedHeaders.deposit || this.selectedHeaders.deposit.trim() === '') {
      this.coreService.showMessage("Please select a Deposits field from the dropdown.");
      return;
    }
   
    if (this.excelfileList && this.excelfileList.length > 0) {
      this.mapData();
      
    const excelDateToJSDate = (serial: number) => {
      const dateInfo = new Date((Math.floor(serial - 25569) * 86400) * 1000);
       return isNaN(dateInfo.getTime()) ? null : dateInfo;
    };
      const hasInvalidDate = this.mappedData.some(row => {
      const dateVal = row.date;
      if (typeof dateVal === 'number') {
        return !excelDateToJSDate(dateVal);
      } else if (typeof dateVal === 'string') {
        const parsedDate = Date.parse(dateVal);
        return isNaN(parsedDate);
      } else {
        return true;
      }
    });

    if (hasInvalidDate) {
      this.coreService.showMessage("One or more rows contain invalid dates. Please make sure dates are valid (either in Excel date format or proper string).");
      return;
    }

    const hasInvalidFields = this.mappedData.some(row => {
        let desc = row.description,
          payee = row.payee,
          reference = row.reference,
          withdrawals = row.withdrawals,
          deposit = row.deposit;
          if (typeof desc !== 'string' || desc.length > 250) {
            this.coreService.showMessage("One or more rows contain invalid descriptions. Ensure all descriptions are strings and not more than 250 characters.");
            return true;
          } else if (typeof payee !== 'string' || payee.length > 250) {
            this.coreService.showMessage("One or more rows contain invalid payee. Ensure all payee are strings and not more than 250 characters.");
            return true;
          } else if (typeof reference !== 'string' || reference.length > 100) {
            this.coreService.showMessage("One or more rows contain invalid references. Ensure all references are strings and not more than 100 characters.");
            return true;
          } else if (withdrawals && typeof withdrawals !== 'number') {
            this.coreService.showMessage("One or more rows contain invalid withdrawals. Ensure all withdrawals are numeric.");
            return true;
          } else if (deposit && typeof deposit !== 'number') {
            this.coreService.showMessage("One or more rows contain invalid deposits. Ensure all deposits are numeric.");
            return true;
          }
        
          return false;
      
    });
    
    if (hasInvalidFields) {
      return;
    }
  

      this.impRes = null;
      let file: File = this.excelfileList[0];
      let formData: FormData = new FormData();
      formData.append('file', file, file.name);
      formData.append('show_reason', '1');
      formData.append('start', '');
      formData.append('limit', '');
      formData.append('genSysUnit', '')
      formData.append('mappedDataRec', JSON.stringify(this.mappedData));
      formData.append('recnltn_from_date', this.apiService.formatDate(this.from_date));
      formData.append('recnltn_to_date', this.apiService.formatDate(this.to_date));
      formData.append('recnltn_account_id', this.account);

    

      this.isSubmitInProg = true;
      this.inProgressMg = "Don't close this window wait till complete,Processing.....";

      this.added_rows_count = 0;
      this.existing_rows_count = 0;
      this.existing_rows = [];

      this.apiService.importReconciliationExcelSave(formData).subscribe((res) => {
        this.inProgressMg = "";
        this.closeModal.nativeElement.click();
        if (res.message)
          this.coreService.showMessage(res.message);
        else
          this.coreService.showMessage(res.error);

        this.getBankTransactions();
      });
      this.clearForm();
      
    }
  }

  deleteReconciliation(recnltnId) {
    if (confirm("Do you wish to void this entry?")) {
      let searchval = new FormData();
      searchval.append('recnltn_id', recnltnId);
      this.apiService.deleteReconciliation(searchval).subscribe((res) => {
        if (res.message)
          this.coreService.showMessage('Voided Successfully');
        else
          this.coreService.showMessage(res.error);

        this.getBankTransactions();
      });
    }
  }


}
